import { render, staticRenderFns } from "./ListOntologies.vue?vue&type=template&id=efcc5a5e&scoped=true"
import script from "./ListOntologies.vue?vue&type=script&lang=js"
export * from "./ListOntologies.vue?vue&type=script&lang=js"
import style0 from "./ListOntologies.vue?vue&type=style&index=0&id=efcc5a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcc5a5e",
  null
  
)

export default component.exports